var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isDarkMode,attrs:{"id":"app"}},[_c('Header',[_c('SwitchComponent',{model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }